export const MAX_FOOTER_ITEMS = 10;

const emptyField = {
    en_text: '',
    es_text: '',
    fr_text: '',
    pt_text: '',
    url: '',
    newTab: false
};

export const DEF_INITIAL_VALUES = Array(4).fill(null).map(() => ({
    en_title: '',
    es_title: '',
    fr_title: '',
    pt_title: '',
    fields: Array(MAX_FOOTER_ITEMS).fill(null).map(() => ({ ...emptyField }))
}));